var AssetDefectListModal = /** @class */ (function () {
    function AssetDefectListModal() {
    }
    return AssetDefectListModal;
}());
export { AssetDefectListModal };
